export default __webpack_public_path__ + "static/media/300.605f9698.png";